export default __webpack_public_path__ + "static/media/entete_gauche_index.7439dff6.png";